<div class="container" ID="AddAreaContainer"  style="width: 20%;">
    <H1>Add Area</H1>
  
    <div>
    
  
  
      <div class="form-group">
        <label>Province:</label>

        <select class="form-control" name="Province" type="text" [(ngModel)]="Province" required
          placeholder="Enter Province" (change)="ProvinceNameChanged()">
          <option *ngFor="let Province of Provinces; let i =index" value={{Province}}>{{Province}}
          </option> 
          </select>
      </div>

      <div class="form-group" *ngIf="Province">
        <label>Area:</label>
        <input class="form-control" name="Area" type="text" [(ngModel)]="Area" required
          placeholder="Enter Area" maxlength="30" (ngModelChange)="AreaNameChanged()"/>

          <label style="margin-top: 20px;">Exsisting Areas:</label>
            <select class="selectpicker form-control" multiple="true" style="padding-bottom: 0px;" [(ngModel)]="PossibleArea" (change)="PossibleAreaChanged()">
                <option *ngFor="let item of PossibleAreas; let i =index" value={{item}}>{{item}}
                </option> 
            </select>
       

      </div>
  
  
      <div class="form-group" style="display: inline-flex;">
  
          <div style="float: left;margin-right: 20px;">
              <button class="btn btn-primary btn-lg btn-block" type="submit" ID="AddAreaBackBtn"  (click)="Back()">Back</button>
          </div>
  
  
          <div style="float: left;margin-right: 20px;margin-left:20px;">
              <button class="btn btn-warning btn-lg btn-block" type="submit"  (click)="Reset()">Reset</button>
          </div>
  
          <div style="float: right;margin-left:20px;">
              <button class="btn btn-success btn-lg btn-block" type="submit" [disabled]="!Area || !Province" (click)="Save()">Save</button>
          </div>
          
      </div>
  
  
      
  
    </div>
  
  </div>
  
  <div style="float: right;margin-left:20px;">
    <button class="btn btn-success btn-lg btn-block" id="ErrorButton" (click)="open(content)" style="display: none;">
    </button>
  </div>
   <ng-template #content let-modal ID="Errormessage">
        <div class="modal-header">
            <h4 class="modal-title" 
                id="modal-basic-title">
                {{PopupTitle}}
            </h4>
            <button type="button" class="close"
                    aria-label="Close" (click)=
                    "modal.dismiss('Cross click')">
      
                <span aria-hidden="true">
                    ×
                </span>
            </button>
        </div>
        <div class="modal-body">
            <form>
                <div class="form-group">
                    <label for="dateOfBirth">
                        {{DisplayErrormessage}}
                    </label>
                </div>
            </form>
        </div>
        <div class="modal-footer">
            <button type="button" 
                class="btn btn-success btn-lg btn-block" 
                (click)="modal.close('Save click')">
                Done
            </button>
        </div>
    </ng-template>
